"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlayerHitCommand = void 0;
const draw_deck_player_action_1 = require("../../actions/draw-deck-player-action");
const player_command_1 = require("./player-command");
const logic_types_1 = require("../../logic-types");
const player_bust_single_rule_1 = require("../../game-rules/player-bust-single-rule");
const show_controls_rule_1 = require("../../game-rules/show-controls-rule");
const player_bust_fork_rule_1 = require("../../game-rules/player-bust-fork-rule");
const move_next_player_rule_1 = require("../../game-rules/move-next-player-rule");
const reach_target_score_fork_rule_1 = require("../../game-rules/reach-target-score-fork-rule");
const croupier_auto_deal_rule_1 = require("../../game-rules/croupier-auto-deal-rule");
const send_all_results_rule_1 = require("../../game-rules/send-all-results-rule");
const common_rules_1 = require("./common-rules");
class PlayerHitCommand {
    static isCommand(command) {
        return command instanceof PlayerHitCommand;
    }
    serializeToString() {
        return player_command_1.CommandTypes.Hit;
    }
    validateCommand(context) {
        return context.gameState.isAllowed(logic_types_1.PlayerControls.Hit);
    }
    preprocessActions() {
        return [];
    }
    executeCommand(commandHash, instant, context) {
        return __awaiter(this, void 0, void 0, function* () {
            context.gameState.setRoundState(logic_types_1.RoundState.Transition, instant);
            const playerId = context.playerManager.getCurrentPlayerId();
            const drawDeckAction = new draw_deck_player_action_1.DrawDeckPlayerAction(context.playerManager.board, playerId);
            drawDeckAction.execute();
            yield context.dealProcessor.disclosePendingCards(commandHash);
            drawDeckAction.resolve();
            const player = context.playerManager.playerFromId(playerId);
            context.eventQueue.enqueue({
                type: "onDrawDeckPlayer",
                instant,
                payload: {
                    player: player.clone(),
                    cardIndex: drawDeckAction.cardIndex,
                },
            });
            if (context.logicVersion <= 1) {
                yield this.resultRulesV1(context, playerId).execute(commandHash, instant, context);
            }
            else {
                yield this.resultRules(context, playerId).execute(commandHash, instant, context);
            }
        });
    }
    resultRules(context, playerId) {
        if (context.playerManager.hasSinglePlayer) {
            const playerBustRule = new player_bust_single_rule_1.PlayerBustSingleRule(playerId);
            const reachTargetScoreRule = new reach_target_score_fork_rule_1.ReachTargetScoreForkRule(playerId, new show_controls_rule_1.ShowControlsRule(), common_rules_1.CommonRules.endRoundRules());
            playerBustRule.setNext(reachTargetScoreRule);
            return playerBustRule;
        }
        const playerNextTurn = context.playerManager.playerNextTurn(playerId);
        if (playerNextTurn) {
            return new player_bust_fork_rule_1.PlayerBustForkRule(playerId, common_rules_1.CommonRules.moveNextPlayerRules(context, playerNextTurn.playerId), new reach_target_score_fork_rule_1.ReachTargetScoreForkRule(playerId, new show_controls_rule_1.ShowControlsRule(), common_rules_1.CommonRules.moveNextPlayerRules(context, playerNextTurn.playerId)));
        }
        return new player_bust_fork_rule_1.PlayerBustForkRule(playerId, common_rules_1.CommonRules.endRoundRules(), new reach_target_score_fork_rule_1.ReachTargetScoreForkRule(playerId, new show_controls_rule_1.ShowControlsRule(), common_rules_1.CommonRules.endRoundRules()));
    }
    //
    // Legacy
    //
    resultRulesV1(context, playerId) {
        if (context.playerManager.hasSinglePlayer) {
            const playerBustSingleRule = new player_bust_single_rule_1.PlayerBustSingleRule(playerId);
            const showControlsRule = new show_controls_rule_1.ShowControlsRule();
            const reachTargetScoreRule = new reach_target_score_fork_rule_1.ReachTargetScoreForkRule(playerId, showControlsRule, this.finalPlayerRules());
            playerBustSingleRule.setNext(reachTargetScoreRule);
            return playerBustSingleRule;
        }
        const playerNextTurn = context.playerManager.playerNextTurn(playerId);
        if (playerNextTurn) {
            return new player_bust_fork_rule_1.PlayerBustForkRule(playerId, this.moveNextPlayerRules(playerNextTurn), this.continueNextPlayerRules(playerId, playerNextTurn));
        }
        return new player_bust_fork_rule_1.PlayerBustForkRule(playerId, this.finalPlayerRules(), this.continueFinalPlayerRules(playerId));
    }
    moveNextPlayerRules(nextPlayer) {
        const moveNextPlayerRules = new move_next_player_rule_1.MoveNextPlayerRule(nextPlayer.playerId);
        const showControlsRule = new show_controls_rule_1.ShowControlsRule();
        moveNextPlayerRules.setNext(showControlsRule);
        return moveNextPlayerRules;
    }
    continueNextPlayerRules(playerId, nextPlayer) {
        const showControlsRule = new show_controls_rule_1.ShowControlsRule();
        return new reach_target_score_fork_rule_1.ReachTargetScoreForkRule(playerId, showControlsRule, this.moveNextPlayerRules(nextPlayer));
    }
    finalPlayerRules() {
        const croupierAutoDealRule = new croupier_auto_deal_rule_1.CroupierAutoDealRule();
        const sendAllResultsRule = new send_all_results_rule_1.SendAllResultsRule();
        croupierAutoDealRule.setNext(sendAllResultsRule);
        return croupierAutoDealRule;
    }
    continueFinalPlayerRules(playerId) {
        const showControlsRule = new show_controls_rule_1.ShowControlsRule();
        return new reach_target_score_fork_rule_1.ReachTargetScoreForkRule(playerId, showControlsRule, this.finalPlayerRules());
    }
}
exports.PlayerHitCommand = PlayerHitCommand;
